import queryString from 'query-string';

export class ViewController {
    constructor(container) {
        this.container = container;
        
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleListClick = this.handleListClick.bind(this);

        const select = container.find('.ordering-select'),
            list = container.find('.ordering-list');
        
        if (select.length !== 0) {
            this.ordering = select.val();
            select.on('change', this.handleSelectChange);
        }

        if (list.length !== 0) {
            list.on('click', '.v4-view-ordering-link', this.handleListClick);
            this.ordering = list.find('.v4-view-ordering-link.active').data('ordering');
        }

        this.select = select;
        this.list = list;
    }

    updateControls(ordering) {
        const { select, list } = this;
        
        if (select != null && select.length !== 0)
            select.val(ordering);

        if (list != null && list.length !== 0) {
            list.find('.v4-view-ordering-link')
                .removeClass('active')
                .filter(`[data-ordering="${ordering}"]`)
                .addClass('active');
        }
    }

    setOrdering(newOrdering) {
        if (this.ordering === newOrdering)
            return;

        this.updateControls(newOrdering);
        const params = queryString.parse(location.search);
        params['sort_by'] = newOrdering;
        let [, url] = /^(.*?)(?:\?.*)?$/.exec(location.href) || [];
        if (!url)
            return;
        /* Shopify's collection ordering only works from the actual collection URL. */
        url = url.replace('/products', '/collections/all');
        // if(url.search('/collections?') !== -1)
        //     url = url.replace('/collections', '/collections/all');

        url += '?' + queryString.stringify(params);
        location.href = url;
        this.ordering = newOrdering;
    }

    handleListClick(e) {
        e.preventDefault();
        e.stopPropagation();
        const ordering = jQuery(e.target)
            .closest('.v4-view-ordering-link')
            .data('ordering');
        if (ordering)
            this.setOrdering(ordering);
    }

    handleSelectChange(e) {
        e.preventDefault();
        const newOrdering = this.select.val();
        this.setOrdering(newOrdering);
    }
}
